import React, { useEffect, useState } from 'react'
import { Vertical } from '@gravitate-js/excalibrr'
import moment from 'moment'
import { PriceLoadedGrid } from './PriceLoadedGrid'
import { SelectedPriceDetails } from './SelectedPriceDetails'
import { MonthlyVolumeChart } from './MonthlyVolumeChart'
import { useDirectiveContext } from '../../DirectiveContext'

export const PriceMetrics = ({ selectedPrice, directiveMetrics, metricsLoading }) => {
  const [priceMetrics, setPriceMetrics] = useState()
  const { selectedDate } = useDirectiveContext()
  useEffect(() => {
    if (!directiveMetrics) return
    const getVolume = () => {
      const filteredVolumes = []
      let directiveTotalVolume = 0
      let priceTotalVolume = 0
      const isCurrentMonth = selectedDate.isSame(new Date(), 'month')
      directiveMetrics.directive_by_day.forEach((volume) => {
        const match = volume.costs.find((price) => price.price.curve_id === selectedPrice.curve_id)
        const dayDate = moment(volume.date)

        directiveTotalVolume += volume.loaded
        if (match) {
          const newRow = {
            ...match.price,
            date: `${dayDate.month() + 1}/${dayDate.date()}`,
            price_difference: match.price_difference,
            cost_difference: match.cost_difference,
            is_best: match.is_best,
            price_per_volume: match.price_per_volume,
            loaded: match.volume,
            scheduled: match.scheduled,
            directive_loaded: volume.loaded - match.volume - (match.scheduled || 0),
            total_directive: volume.loaded,
            pace: volume.pace,
          }

          if (!isCurrentMonth || (isCurrentMonth && moment().date() < dayDate.date())) {
            return
          }
          filteredVolumes.push(newRow)
          priceTotalVolume += match.volume
        } else {
          filteredVolumes.push({ date: `${dayDate.month() + 1}/${dayDate.date()}` })
        }
      })

      return {
        volumes: filteredVolumes,
        priceTotalVolume,
        directiveTotalVolume,
      }
    }
    const getPricePerformance = () => {
      const priceData = directiveMetrics.prices_by_day.find((price) => price.curve_id)
      if (priceData) {
        return {
          ...priceData,
          total_best_price_days_cost: priceData.good_net_cost,
          total_not_best_price_days_cost: priceData.bad_net_cost,
        }
      }
      return {}
    }
    const volumeData = getVolume()
    const noPriceDays = volumeData.volumes.filter((volume) => !volume.price_difference).length
    setPriceMetrics({
      ...volumeData,
      priceData: { ...getPricePerformance(), no_price_days: noPriceDays },
      rateableVolume: directiveMetrics.rateable_volume,
    })
  }, [directiveMetrics, selectedPrice])
  if (!priceMetrics) return null
  return (
    <>
      <MonthlyVolumeChart isPrice metricsLoading={metricsLoading} chartData={priceMetrics} />
      <Vertical flex={4} className='mx-3'>
        <SelectedPriceDetails
          metricsLoading={metricsLoading}
          selectedPrice={selectedPrice}
          priceMetrics={priceMetrics}
        />
        <PriceLoadedGrid metricsLoading={metricsLoading} priceMetrics={priceMetrics} selectedPrice={selectedPrice} />
      </Vertical>
    </>
  )
}
